import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";

const columns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "username",
    headerName: "User Name",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "timestamp",
    headerName: "Time Stamp",
    minWidth: 150,
    flex: 2,
    type: "date",
  },
  {
    field: "ipAddress",
    headerName: "IP Address",
    headerAlign: "right",
    type: "number",
    minWidth: 100,
    flex: 1,
  },
  {
    field: "action",
    headerName: "Action",
    minWidth: 100,
    flex: 2,
  },
  {
    field: "results",
    headerName: "Results",
    minWidth: 120,
    flex: 2,
  },
  {
    field: "error",
    headerName: "error",
    minWidth: 70,
    flex: 1,
  },
];

export default function LogTable({ username }) {
  const [logs, setLogs] = React.useState([]);
  const usernames = [
    ...new Set(
      logs.map((log) => {
        return log["username"];
      })
    ),
  ];
  const [selectedUsername, setSelectedUsername] = React.useState("");
  const [err, setErr] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    let un = "";
    if (username) un = "/" + username;
    axios
      .get(`/getLogs${un}`)
      .then((res) => {
        setLogs(res.data.logs);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  const handleUsernameChange = (event, value) => {
    setSelectedUsername(value);
  };

  const filteredRows = selectedUsername
    ? logs.filter((log) => log.username === selectedUsername)
    : logs;

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <Box sx={{ height: 900, width: "100%" }}>
          {(!username && logs) &&
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={usernames}
            value={selectedUsername}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="User" />}
            onChange={handleUsernameChange}
          />
}
          <DataGrid
            loading={isLoading}
            rows={filteredRows}
            columns={columns}
            pageSize={20}
            rowsPerPageOptions={[15]}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      )}
    </React.Fragment>
  );
}
